import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      const allowedRoutes = [
        "/WebPanel/account-login",
        "/WebPanel/maintenance",
        "/maintenance",
      ];

      if (environment.isMaintainanceMode) {
        if (allowedRoutes.includes(state.url)) {
          return true;
        }

        this.router.navigate(["/maintenance"]);
        return false;
      }

      return true;
  }

}
